<template>
  <page>
    <div>
      <v-flex xs12>
        <form>
          <v-expansion-panels>
          <v-expansion-panel>
              <v-expansion-panel-header>
              <div>
                <v-icon>mdi-filter-variant</v-icon> Filters
              </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex xl3 lg6 xs6>
                        <v-autocomplete :items="scheme" v-model="filter.scheme" :label="label.scheme" item-text="label" item-value="value" data-vv-name="scheme" :data-vv-as="label.scheme" :error-messages="errors.collect('scheme')" @change="getPlanNo($event)" clearable></v-autocomplete>
                      </v-flex>
                      <v-flex xl3 lg6 xs6>
                        <v-autocomplete :items="planno" v-model="filter.planNo" :label="label.planNo" item-text="label" item-value="value" data-vv-name="planNo" :data-vv-as="label.planNo" :error-messages="errors.collect('planNo')" clearable></v-autocomplete>
                      </v-flex>
                      <v-flex xl3 lg6 xs6>
                        <v-autocomplete :items="tariff" v-model="filter.tariff" :label="label.tariff" item-text="label" item-value="value" data-vv-name="tariff" :data-vv-as="label.tariff" :error-messages="errors.collect('tariff')" clearable></v-autocomplete>
                      </v-flex>
                      <v-flex xl3 lg6 xs6>
                        <v-autocomplete :items="buscls" v-model="filter.busCls" :label="label.busCls" item-text="label" item-value="value" data-vv-name="busCls" :data-vv-as="label.busCls" :error-messages="errors.collect('busCls')" clearable></v-autocomplete>
                      </v-flex>
                      <v-flex xl3 lg6 xs6>
                        <v-autocomplete :items="benefit" v-model="filter.benefit" :label="label.benefit" item-text="label" item-value="value" data-vv-name="benefit" :data-vv-as="label.benefit" :error-messages="errors.collect('benefit')" clearable></v-autocomplete>
                      </v-flex>
                     <v-flex xl3 lg6 xs6>
                        <cal-picker v-model="filter.effDate" :label="label.effDate" :data-vv-as="label.effDate" data-vv-name="effDate"></cal-picker>
                     </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </form>
      </v-flex>
        <v-spacer class="mt-2"></v-spacer>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click.native="doNew">
            New Tariff Factor<v-icon right>mdi-plus</v-icon>
          </v-btn>
        </v-card-title>
        <v-flex>
          <v-card>
            <v-data-table :headers="headers" :items="items" v-bind:options.sync="pagination" :server-items-length="totalItems" :loading="loading" :footer-props="{'items-per-page-options': itemsPerPage }" :no-data-text="noDataText">
              <template v-slot:item="row"><tr>
                <td class="text-xs-left">{{ row.item.scheme }} </td>
                <td class="text-xs-left">{{ row.item.planNo }} </td>
                <td class="text-xs-left">{{ row.item.tariff }} </td>
                <td class="text-xs-left">{{ row.item.busCls }} </td>
                <td class="text-xs-left">{{ row.item.benefit }} </td>
                <td class="text-xs-left">{{ row.item.seqNo }} </td>
                <td class="text-xs-left">{{ formatDate(row.item.effDate) }} </td>
                <td class="text-xs-left">{{ formatDate(row.item.expDate) }} </td>
                <td class="text-xs-left">{{ row.item.fact1 }} </td>
                <td class="text-xs-left">{{ row.item.fact2 }} </td>
                <td class="text-xs-left">{{ row.item.fact3 }} </td>
                <td class="text-xs-left">{{ row.item.fact4 }} </td>
                <td class="text-xs-left">{{ row.item.fact5 }} </td>
                <td class="text-xs-left">{{ row.item.fact6 }} </td>
                <td class="table-action-header">
                  <table-action :rowData="row" query @query="doQuery(row.item)" review @review="doReview(row.item)" remove @remove="doPromptRemove(row.item)"></table-action>
                </td>
              </tr></template>
            </v-data-table>
          </v-card>
        </v-flex>
        <confirm v-model="promptRemove" @ok="doDelete">
          <p>Are you sure you want to delete the Tariff Factor?</p>
          <div class="queryValue">Scheme: {{selectedTariffFact.scheme}}<br/>
            Plan No.: {{selectedTariffFact.planNo}}<br/>
            Tariff: {{selectedTariffFact.tariff}}<br/>
            Business Class: {{selectedTariffFact.busCls}}<br/>
            Benefit: {{selectedTariffFact.benefit}}<br/>
            Sequence No.: {{selectedTariffFact.seqNo}}<br/>
            Effective Date: {{selectedTariffFact.effDate}}<br/>
          </div>
         </confirm>
      </v-card>
    </div>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { formatDisplayDate, formatDisplayDateTime2, removeTime } from '@/utils/date'
import clone from 'clone'

export default {
  data() {
    return {
      toogleArray: [false],
      scheme: [],
      planno: [],
      tariff: [],
      buscls: [],
      benefit: [],
      items: [],
      label: {
        scheme: 'Scheme',
        planNo: 'Plan No.',
        tariff: 'Tariff',
        busCls: 'Business Class',
        benefit: 'Benefit',
        effDate: 'Effective Date'
      },
      filter: {
        scheme: null,
        planNo: null,
        tariff: null,
        busCls: null,
        benefit: null,
        effDate: null
      },
      loading: false,
      totalItems: 0,
      headers: [
        { text: 'Scheme', align: 'left', value: 'scheme' },
        { text: 'Plan', align: 'left', value: 'planNo' },
        { text: 'Tariff', align: 'left', value: 'tariff' },
        { text: 'Business Class', align: 'left', value: 'busCls' },
        { text: 'Benefit', align: 'left', value: 'benefit' },
        { text: 'Seq No.', align: 'left', value: 'seqNo' },
        { text: 'Effective Date', align: 'left', value: 'effDate' },
        { text: 'Expiry Date', align: 'left', value: 'expDate' },
        { text: 'Factor 1', align: 'left', value: 'fact1' },
        { text: 'Factor 2', align: 'left', value: 'fact2' },
        { text: 'Factor 3', align: 'left', value: 'fact3' },
        { text: 'Factor 4', align: 'left', value: 'fact4' },
        { text: 'Factor 5', align: 'left', value: 'fact5' },
        { text: 'Factor 6', align: 'left', value: 'fact6' },
        TableConst.tableActionHeader
      ],
      promptRemove: false,
      selectedTariffFact: {
        scheme: null,
        planNo: null,
        tariff: null,
        busCls: null,
        benefit: null,
        seqNo: null,
        effDate: null
      },
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  async mounted() {
    await this.$store.dispatch('tariffFactInit')
    this.doInit()
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('commonsInit')])
      this.getCommonDataListDropDown('scheme')
      this.getCommonDataList2('planno', this.filter.scheme)
      this.getCommonDataListDropDown('tariff')
      this.getCommonDataListDropDown('buscls')
      this.getCommonDataListDropDown('benefit')
      this.fetchData(true)
    },
    async fetchData(options) {
      this.resetMessages()
      const apiURI = this.menu.getTariffFactList
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          let messageFilters = clone(this.filter)

          if (messageFilters.effDate !== null && messageFilters.effDate !== '') {
            messageFilters.effDate = formatDisplayDateTime2(removeTime(messageFilters.effDate))
          }

          const result = await this.$http.get(
            filterQuery(expandURI(apiURI, expand), messageFilters, this.pagination.sortBy, this.pagination.sortDesc)
          )
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((tariffFact) => {
                const convertList = {
                  scheme: tariffFact.scheme,
                  planNo: tariffFact.planNo,
                  tariff: tariffFact.tariff,
                  busCls: tariffFact.busCls,
                  benefit: tariffFact.benefit,
                  seqNo: tariffFact.seqNo,
                  effDate: tariffFact.effDate,
                  expDate: tariffFact.expDate,
                  fact1: tariffFact.fact1,
                  fact2: tariffFact.fact2,
                  fact3: tariffFact.fact3,
                  fact4: tariffFact.fact4,
                  fact5: tariffFact.fact5,
                  fact6: tariffFact.fact6
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    doClearFilters() {
      this.resetMessages()
      this.filter.scheme = null
      this.filter.planNo = null
      this.filter.tariff = null
      this.filter.busCls = null
      this.filter.benefit = null
      this.filter.effDate = null
      this.fetchData(false)
    },
    doFilters() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.fetchData(false)
        } else {
          this.promptFieldCheck()
        }
      })
    },
    getPlanNo(data) {
      this.getCommonDataList2('planno', this.filter.scheme)
    },
    doNew() {
      const commit = {
        tranMode: 'New',
        scheme: null,
        planNo: null,
        tariff: null,
        busCls: null,
        benefit: null,
        seqNo: null,
        effDate: null,
        fact1: null,
        fact2: null,
        fact3: null,
        fact4: null,
        fact5: null,
        fact6: null
      }
      sessionStorage.setItem('tariffFact', JSON.stringify(commit))
      this.$store.commit('TARIFFFACT_COMMIT_KEY', commit)
      this.$router.push({ name: 'pckgTariffFactDetail' })
    },
    doReview(data) {
      const commit = {
        tranMode: 'Review',
        scheme: data.scheme,
        planNo: data.planNo,
        tariff: data.tariff,
        busCls: data.busCls,
        benefit: data.benefit,
        seqNo: data.seqNo,
        effDate: data.effDate,
        fact1: data.fact1,
        fact2: data.fact2,
        fact3: data.fact3,
        fact4: data.fact4,
        fact5: data.fact5,
        fact6: data.fact6
      }

      sessionStorage.setItem('tariffFact', JSON.stringify(commit))
      this.$store.commit('TARIFFFACT_COMMIT_KEY', commit)
      this.$router.push({ name: 'pckgTariffFactDetail' })
    },
    doQuery(data) {
      const commit = {
        tranMode: 'Query',
        scheme: data.scheme,
        planNo: data.planNo,
        tariff: data.tariff,
        busCls: data.busCls,
        benefit: data.benefit,
        seqNo: data.seqNo,
        effDate: data.effDate,
        fact1: data.fact1,
        fact2: data.fact2,
        fact3: data.fact3,
        fact4: data.fact4,
        fact5: data.fact5,
        fact6: data.fact6
      }

      sessionStorage.setItem('tariffFact', JSON.stringify(commit))
      this.$store.commit('TARIFFFACT_COMMIT_KEY', commit)
      this.$router.push({ name: 'pckgTariffFactDetail' })
    },
    async doPromptRemove(data) {
      this.resetMessages()
      if (data) {
        try {
          const apiURI = this.menu.checkDeleteTariffFact
          const expand = {
            scheme: data.scheme,
            planNo: data.planNo,
            tariff: data.tariff,
            busCls: data.busCls,
            benefit: data.benefit,
            seqNo: data.seqNo,
            effDate: formatDisplayDateTime2(removeTime(data.effDate))
          }
          await this.$http.get(expandURI(apiURI, expand))
          this.selectedTariffFact.scheme = data.scheme
          this.selectedTariffFact.planNo = data.planNo
          this.selectedTariffFact.tariff = data.tariff
          this.selectedTariffFact.busCls = data.busCls
          this.selectedTariffFact.benefit = data.benefit
          this.selectedTariffFact.seqNo = data.seqNo
          this.selectedTariffFact.effDate = formatDisplayDate(data.effDate)
          this.promptRemove = true
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fieldMessage(data)
            this.notify(data)
          }
        }
      }
    },
    doDelete() {
      this.resetMessages()
      if (this.selectedTariffFact) {
        const apiURI = this.menu.deleteTariffFact
        if (apiURI) {
          const expand = {
            scheme: this.selectedTariffFact.scheme,
            planNo: this.selectedTariffFact.planNo,
            tariff: this.selectedTariffFact.tariff,
            busCls: this.selectedTariffFact.busCls,
            benefit: this.selectedTariffFact.benefit,
            seqNo: this.selectedTariffFact.seqNo,
            effDate: this.selectedTariffFact.effDate
          }
          this.$http
            .delete(expandURI(apiURI, expand))
            .then((result) => {
              const data = result.data
              this.notify(data)
              this.promptRemove = false
              this.doInit()
            })
            .catch((err) => {
              this.promptRemove = false
              const { data } = err.response
              if (data) {
                this.message(data)
              }
            })
        }
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.pkgParam.tariffFact.menu
    }
  },
  watch: {
    'pagination': function (value) {
      this.fetchData(false)
    }
  },
  mixins: [TableConst.default, MessageMixin, commonAjaxMixin]
}
</script>
